import React from 'react';
import cn from 'classnames';
import SIM from '../../../../sim/core';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import basketActions from '../../../../actions/basket';
import U from '../basket_utils';
import F from '../../../common/ticket_stub/ticket_stub_factory';

const mapActions = SIM.actions.map;
const mapEvents  = mapActions.EVENTS;

export default class BasketContent extends React.Component {
  static propTypes = {
    basket: React.PropTypes.object
  };

  closeBasket = () => {
    basketActions.toggleShowTickets();
    basketActions.resetSelectSeatAttempt();
  };

  renderTickets = () => {
    if (!U.hasTickets(this.props.basket)) {
      return <div className="basket__notickets" />;
    }
    const tickets = this.renderSeatingTickets().concat(this.renderGATickets());

    if (tickets &&
      tickets.length > 0
    ) {
      this.props.basket.rawTickets = tickets.map(ticket => {
        if (ticket.props &&
          ticket.props.children &&
          ticket.props.children.props &&
          ticket.props.children.props.ticket
        ) {
          return ticket.props.children.props.ticket;
        }
      });
    }

    return tickets;
  };

  makeRemoveSeatFunc = (ticket) => {
    return function () {
      mapActions.emit(mapEvents.SEAT_REMOVE, ticket.id);
    };
  };

  makeRemoveGaSeatFunc = (ticket) => {
    return function () {
      basketActions.decreaseGASection(ticket.section, ticket.priceCategoryId, ticket.priceType);
    };
  };

  renderSeatingTickets = () => {
    const activeSeats = this.props.basket.activeSeats;
    const priceTypes = this.props.basket.priceTypes;
    const prices = this.props.basket.prices;
    const self = this;

    return U.activeSeatsToTicketDataArray(activeSeats, priceTypes, prices)
      .map(ticket => {
        ticket.basket = this.props.basket;
        const comp = F.makeBasketTicketStub(ticket, this.makeRemoveSeatFunc(ticket));
        return self.stubToLi(comp, ticket.id);
      });
  };

  stubToLi = (comp, id) => {
    return <li key={`seating-${id}`} className="basket__item" data-component="basket-item">
      {comp}
    </li>;
  };

  renderGATickets = () => {
    const gaSeats = this.props.basket.GASeats;
    const priceTypes = this.props.basket.priceTypes;
    const self = this;

    return U.gaSeatsToGaTicketdataArray(gaSeats, priceTypes)
      .map((ticket, index) => {
        // a ga ticket has no uniq id so we create one using the index
        const tmp = Object.assign({}, ticket, {id: ticket.id + index});
        tmp.basket = this.props.basket;
        const comp = F.makeBasketTicketStub(tmp, this.makeRemoveGaSeatFunc(tmp));
        return self.stubToLi(comp, tmp.id);
      });
  };

  render () {
    const basketContentClassName = cn({
      'basket__content': true,
      'is-active': this.props.basket.showTickets
    });
    const basketToggleClass = this.props.basket.showTickets
      ? 'basket__toggle--close'
      : 'basket__toggle--open';
    return (
      <div>
        {
          this.props.basket.showTickets &&
          <div
            className="basket__toggle__backdrop"
            onClick={this.closeBasket}
            role="button" tabIndex="0" />
        }
        <div className={basketContentClassName} data-component="basket-content">
          <div
            className={basketToggleClass}
            onClick={this.closeBasket}
            role="button"
            tabIndex="-1"
            data-component="basket-content-close-button" />
          <ReactCSSTransitionGroup
            component="ul"
            className="basket__tickets"
            transitionName="removeTicket"
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}>
            {this.renderTickets()}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/basket/basket_content/index.js